import React, { Component } from 'react';
import ImageOne from '../Image/imageOne.jpg'
import ImageTwo from "../Image/dash.jpg"

class Projects extends Component {

    render() {
        return (
            <>
            <div className="skills container my-5" id="projects">
                <div className="card">
                    <h4 className="text-muted text-center">My Projects</h4>
                    <hr/>
                    <div className="row">
                    <div className="card mx-auto my-2 col-lg-5 col-md-5 col-10">
                        <div className="card-img-top">
                            <img src={ImageTwo} className="img-fluid" alt="Project" />
                        </div>
                        <h6>Financial Inclusion</h6>
                        <div className="d-inline-block my-2">
                        <a className="btn btn-warning btn-sm" href="https://github.com/daniel-obare/Financial-Inclusion-In-Africa/blob/master/app.R">
                            <small>Github</small>
                        </a>
                        </div>
                    </div>
                    <div className="card mx-auto my-2 col-lg-5 col-md-5 col-10">
                        <div className="card-img-top">
                            <img src={ImageOne} className="img-fluid" alt="Project" />
                        </div>
                        <h6>Rshiny Covid</h6>
                        <div className="d-inline-block my-2">
                        <a className="btn btn-warning btn-sm" href="https://github.com/daniel-obare/round4_Rshiny_covid_19_Survey/blob/master/app.R">
                            <small>Github</small>
                        </a>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            </>
        );
    }
}

export default Projects;